import { Injectable } from '@angular/core';
import { Food } from 'src/app/model/Food';
import { url } from 'inspector';
import {HttpClient, HttpHeaders, HttpParameterCodec, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class EdamamManagerService {

  baseURL = "https://api.edamam.com/api/food-database/parser";
  // appID = "30c1a01a";
  appID = "446be3c2";
  nutritionAppID = "351b44d7";
  // appKey = "c724b7dfb19f708b247978019e56710c";
  appKey = "49fd4eb3f723049972aa945678f17b24";
  nutritionAppKey = "c211aa5269b9f4f05753bda39118872c";

  constructor(
    private http: HttpClient,
   ) {
  }

  

  public searchFood(food: string) : Food[] {
    food = encodeURIComponent(food)
    var url = this.baseURL + "?ingr=" + food + "&app_id=" + this.appID + "&app_key=" + this.appKey;
    console.log("url " + url);
    console.log("food string: " + food);
    var theFoods = new Array();
   
    this.http.get(url).subscribe((data:any) => {
      var foodHintsDict = data["hints"];
      for (var i = 0; i < 10; i++) {
        if (foodHintsDict[i] != "") {
          var f = new Food();
          f.id = foodHintsDict[i]["food"]["foodId"].toString();
          f.name = foodHintsDict[i]["food"]["label"].toString();
          theFoods.push(f);
        }
      }
      return theFoods;
    })
    return theFoods;
    
  }


public getFoodNutritions(theFood?: string, quantity?: string, unit?: string): Observable <any>{
  var url = "/api/food-database/nutrients?app_id=" + this.nutritionAppID + "&app_key=$" + this.nutritionAppKey;
  // url = encodeURIComponent(url)
  var dict = {
   
     "measureURI": quantity,
     "foodId": theFood
  
 };
  const httpOptions = {
    headers : new HttpHeaders({
      'Content-Type':  'application/json'
    })
  }
  return this.http.post<any>(url,dict, httpOptions).pipe(
    catchError(this.handleError)
  )
}


  public async getFoodNutrition(theFood: Food, quantity: string, unit: string) : Promise <any> {
    var url = "/api/food-database/nutrients?app_id=" + this.nutritionAppID + "&app_key=$" + this.nutritionAppKey;
    
    var dict = {"ingredients": [
                  {"quantity": quantity,
                   "measureURI": unit,
                   "foodId": theFood.id}
                  ]
               };
    const theJson = JSON.stringify(dict);
    // const headers = new HttpHeaders().set('access-control-allow-origin', '*');
    // headers.set('Accept', 'application/json');
    // headers.set('Content-Type', 'application/json');
    // console.log("about to send post");
    const httpOptions = {
      headers : new HttpHeaders({
        'Content-Type':  'application/json'
      })
    }
    return this.http.post<any>(url,httpOptions).pipe(
      catchError(this.handleError)
    )

    // return fetch(url, {method: 'POST', headers: {'access-control-allow-origin': '*', 'Accept': 'application/json',
    // 'Content-Type': 'application/json'}, body: theJson}).then(function(response) {
    //   return response.json();
    // })
    // .then(function(myJson) {
    //   console.log(myJson);
    //   theFood.calorieCount = myJson.calories.toString();
    //   return theFood;
    // })
  }

  public createFoodString(s: string) : string {
    var urlEncodedStr = '';
    
    for (var i = 0; i < s.length; i++) {
      const character = s.charAt(i);
      if (character == ' ') {
        urlEncodedStr += '%20';
      } else {
        urlEncodedStr += character;
      }
    }

    return urlEncodedStr;
  }

  public createCorsRequest(method, url) {
    var xhr = new XMLHttpRequest();
    xhr.open(method, url, true);
    return xhr;
  }


  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    // return an observable with a user-facing error message
    return throwError(
      'Something bad happened; please try again later.');
  };
}
